exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer--standard{text-align:center}.footer--standard__link{display:inline-block;margin:4px 8px;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/header/footer.scss
// module id = 766
// module chunks = 0